// external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { MDXProvider } from '@mdx-js/tag'
import { object, string } from 'prop-types'
import MDXRenderer from 'gatsby-mdx/mdx-renderer'

// components
import AnchorButton from 'components/AnchorButton'
import BackgroundImage from 'components/BackgroundImage'
import Header from 'components/Header'
import mdxStyles from './mdx-styles'

// content (required for mdx scope)
import AppealDescriptionBps from 'content/category-content/business-phone-systems/appeal-description.md'
import AppealDescriptionPos from 'content/category-content/pos-systems/appeal-description.md'
import AppealDescriptionPayroll from 'content/category-content/payroll-services/appeal-description.md'

// constants
import { MQ, MIN_HEIGHTS } from 'utils/styleHelpers'

// polyfill for Safari to use smooth scroll with Let's Go button
import smoothscroll from 'smoothscroll-polyfill'

if (typeof window !== 'undefined') {
	smoothscroll.polyfill()
}

const AppealWrap = styled.div`
	font-weight: 300;
	position: relative;
	min-height: ${MIN_HEIGHTS.XS};

	${MQ.S} {
		min-height: ${MIN_HEIGHTS.SM};
	}
`

const AppealContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	padding: 20px 20px 0 20px;
	max-width: 1000px;
	margin: 0 auto;
	width: 100%;
`

const propTypes = {
	appealMdx: string.isRequired,
	appealFrontmatter: object.isRequired,
}

function SectionAppeal({ appealFrontmatter, appealMdx }) {
	const { heroImagePositionSm, heroImagePositionMd, heroImagePositionLg, heroImagePositionXl } = appealFrontmatter
	const heroImageSm = appealFrontmatter.heroImageSm.childImageSharp.fluid.src
	const heroImageMd = appealFrontmatter.heroImageMd.childImageSharp.fluid.src
	const heroImageLg = appealFrontmatter.heroImageLg.childImageSharp.fluid.src
	const heroImageXl = appealFrontmatter.heroImageXl.childImageSharp.fluid.src

	return (
		<AppealWrap>
			<BackgroundImage
				heroImageSm={heroImageSm}
				heroImagePositionSm={heroImagePositionSm}
				heroImageMd={heroImageMd}
				heroImagePositionMd={heroImagePositionMd}
				heroImageLg={heroImageLg}
				heroImagePositionLg={heroImagePositionLg}
				heroImageXl={heroImageXl}
				heroImagePositionXl={heroImagePositionXl}
			/>
			<AppealContainer>
				<MDXProvider components={mdxStyles}>
					<MDXRenderer
						scope={{
							AnchorButton,
							AppealDescriptionBps,
							AppealDescriptionPos,
							AppealDescriptionPayroll,
							Header,
						}}
					>
						{appealMdx}
					</MDXRenderer>
				</MDXProvider>
			</AppealContainer>
		</AppealWrap>
	)
}

export default SectionAppeal

SectionAppeal.propTypes = propTypes
